import axios from "axios";

export const envioNotificacionWass = ({numero, mensaje}) => {

    let data = JSON.stringify({
        "mensaje": mensaje,
        "numero": numero
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/8f3ae696-2f10-4d23-8db7-e0197eff553b',
        // url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/8f3ae696-2f10-4d23-8db7-e0197eff553b',//test
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });


}